module.exports = __webpack_public_path__ + "static/media/IntroDemo05-blank.fc6d1ef5.png";